import { createSlice } from '@reduxjs/toolkit';
import {
  createSupplierFiledLienTemplateExtraReducer,
  createFiledLienTemplateByAdminExtraReducer,
  getFiledLienTemplatesExtraReducer,
  getFiledLienTemplatesByAdminExtraReducer,
} from '../reducers/filedLienTemplatesReducers';
import { FiledLienTemplate } from '@dill/dill-shared';

export interface FiledLienTemplatesInitialState {
  loadingList: string[];
  filedLienTemplates: FiledLienTemplate[];
  supplierFiledLienTemplates: FiledLienTemplate[];
  filedLienTemplatesByAdmin: FiledLienTemplate[];
}

const initialState: FiledLienTemplatesInitialState = {
  loadingList: [],
  filedLienTemplates: [],
  supplierFiledLienTemplates: [],
  filedLienTemplatesByAdmin: [],
};

export const filedLienTemplatesSlice = createSlice({
  name: 'filedLienTemplates',
  initialState,
  reducers: {
    resetFiledLienTemplatesRootState: () => initialState,
  },
  extraReducers(builder) {
    createFiledLienTemplateByAdminExtraReducer(builder);
    getFiledLienTemplatesExtraReducer(builder);
    createSupplierFiledLienTemplateExtraReducer(builder);
    getFiledLienTemplatesByAdminExtraReducer(builder);
  },
});

export const { resetFiledLienTemplatesRootState } = filedLienTemplatesSlice.actions;
